import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import moment from 'moment'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

// import logo from '../../assets/images/logo.png'
import Loader from '../../components/Loader'
// import Table from '../../components/Table'
import { capitalize } from '../../utils/functions'
import { getInvoiceById } from '../../helpers/api/payment'
import { toast } from 'react-toastify'
import { Response } from '../../constants/types'
import { User } from '../../App'

type GuestInvoiceItem = {
  id?: number
  item?: string
  quantity?: number
  price: number | string
  subTotal: number
  SGST: number
  SGSTValue: number
  CGST: number
  CGSTValue: number
  IGST: number
  IGSTValue: number
  GSTWithoutITC: number
  GSTWithoutITCValue: number
  Vat: number
  vatValue: number
  compensationCess: number
  compensationCessValue: number
  serviceTax: number
  serviceTaxValue: number
}

type Invoice = {
  id: number
  createdAt: string
  guestInvoiceItem: GuestInvoiceItem[]
  itemTotal: number
  CGSTTotal: number
  SGSTTotal: number
  roomNo: string
  hotel: User
}

const columns = [
  { Header: 'Order Id', accessor: 'id' },
  { Header: 'Items', accessor: 'item' },
  { Header: 'Quantity', accessor: 'quantity' },
  { Header: 'Price', accessor: 'price' },
  { Header: 'Total', accessor: 'subTotal' },
]

const getTotals = (data: any[], key: string) => {
  let total = 0
  data.forEach((item) => {
    total += item[key]
  })
  return total
}

const ViewPublicInvoice = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>()
  const [invoice, setInvoice] = useState<Invoice>()
  const [itemList, setItemList] = useState<GuestInvoiceItem[]>([])
  const [pageLoad, setPageLoad] = useState<boolean>(false)

  const printDocument = () => {
    const input = document.getElementById('invoiceCard')
    if (input) {
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL('image/png')
        const pdf = new jsPDF()
        const imgProps = pdf.getImageProperties(canvas)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width
        if (window.screen.width < 700) {
          pdfHeight = pdf.internal.pageSize.getHeight()
        }
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight)
        // pdf.output('dataurlnewwindow');
        pdf.save('download.pdf')
      })
    }
  }

  const getInvoiceData = useCallback(
    async (params?: any) => {
      try {
        setPageLoad(true)
        let res: Response = (await getInvoiceById(
          invoiceId,
          params,
        )) as Response
        const invoiceData = res?.data?.data?.[0]
        if (invoiceData) {
          setInvoice(invoiceData)
          let itemListData = invoiceData?.guestInvoiceItem
          // const total = {
          //   id: '-',
          //   item: '-',
          //   quantity: 'Grand Total',
          //   price: getTotals(itemListData, 'price'),
          //   CGSTValue: getTotals(itemListData, 'CGSTValue'),
          //   GSTWithoutITCValue: getTotals(itemListData, 'GSTWithoutITCValue'),
          //   IGSTValue: getTotals(itemListData, 'IGSTValue'),
          //   SGSTValue: getTotals(itemListData, 'SGSTValue'),
          //   vatValue: getTotals(itemListData, 'vatValue'),
          //   compensationCessValue: getTotals(
          //     itemListData,
          //     'compensationCessValue',
          //   ),
          //   serviceTaxValue: getTotals(itemListData, 'serviceTaxValue'),
          //   subTotal: getTotals(itemListData, 'subTotal'),
          // }
          // itemListData.push(total)
          setItemList(itemListData)
        }
      } catch (error: any) {
        toast.error(capitalize(error.errorMessage))
      } finally {
        setPageLoad(false)
      }
    },
    [invoiceId],
  )

  useEffect(() => {
    getInvoiceData()
  }, [getInvoiceData])

  return (
    <>
      {pageLoad ? (
        <Loader />
      ) : (
        <div>
          {/* <div className="page-title-box mt-2 pb-10 border-bottom-2">
            <div className="col">
              <h2 className="page-title">Invoice</h2>
            </div>
          </div> */}

          <div className="card bg-white" id="invoiceCard">
            <div className="card-body p-md-5 ">
              <p className="text-center fs-3 fw-bold">Tax Invoice</p>

              <div className="d-flex justify-content-between mt-4">
                <div>
                  <p className="fs-4 fw-bold">{invoice?.hotel?.name}</p>
                  <p>
                    Address: <span>{invoice?.hotel?.address}</span>
                  </p>
                  <p>
                    GST No.: <span>{invoice?.hotel?.GST}</span>
                  </p>
                  <p>
                    Invoice No.: <span>{invoice?.id}</span>
                  </p>
                  <p>
                    Invoice Date:{' '}
                    <span>
                      {moment(invoice?.createdAt).local().format('DD-MMM-YYYY')}
                    </span>
                  </p>
                  <p>
                    Room No.: <span>{invoice?.roomNo}</span>
                  </p>
                </div>

                {/* <div>
                  <img src={logo} alt="" height={49} />
                </div> */}
              </div>
              <hr />
              <div>
                <div className="fs-4 fw-bold">Order summary</div>
              </div>
              <div>
                {/* <Table columns={columns} data={itemList} /> */}
                {
                  // @ts-ignore
                  <Table className="text-center mt-2 border border-2 border-dark">
                    {
                      // @ts-ignore
                      <Thead>
                        {
                          // @ts-ignore
                          <Tr>
                            {columns?.map((col) => {
                              return (
                                // @ts-ignore
                                <Th className="p-1">{col?.Header}</Th>
                              )
                            })}
                          </Tr>
                        }
                      </Thead>
                    }
                    {
                      // @ts-ignore
                      <Tbody>
                        {itemList?.map((itemData) => {
                          const {
                            id,
                            item,
                            quantity,
                            price,
                            SGST = 0,
                            SGSTValue = 0,
                            CGST = 0,
                            CGSTValue = 0,
                            IGST = 0,
                            IGSTValue = 0,
                            GSTWithoutITC = 0,
                            GSTWithoutITCValue = 0,
                            Vat = 0,
                            vatValue = 0,
                            compensationCess = 0,
                            compensationCessValue = 0,
                            serviceTax = 0,
                            serviceTaxValue = 0,
                            subTotal,
                          } = itemData
                          return (
                            // @ts-ignore
                            <Tr className="border-top border-dark">
                              {
                                // @ts-ignore
                                <Td>{id}</Td>
                              }
                              {
                                // @ts-ignore
                                <Td>{item}</Td>
                              }
                              {
                                // @ts-ignore
                                <Td>{quantity}</Td>
                              }
                              {
                                // @ts-ignore
                                <Td>{price}</Td>
                              }
                              {
                                // @ts-ignore
                                <Td>{subTotal}</Td>
                              }
                            </Tr>
                          )
                        })}
                      </Tbody>
                    }
                  </Table>
                }
                <div className="d-flex justify-content-end text-end mt-3">
                  <div
                    style={{ width: '300px' }}
                    className="flex flex-col gap-2"
                  >
                    <div className="row border-top border-2 fs-4">
                      <div className="col">Grand Total</div>
                      <div className="col-4">
                        {getTotals(itemList, 'subTotal')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col d-flex justify-content-end mt-5">
                <button
                  className="waves-effect waves-light btn btn-primary"
                  type="button"
                  onClick={printDocument}
                >
                  <i className="bi bi-printer-fill"></i> Print
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ViewPublicInvoice
